export default __webpack_public_path__ + "static/media/content-header-bg.610689f2.svg";